function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cacde9;}.cls-1,.cls-23{opacity:0.5;}.cls-1,.cls-23,.cls-6{isolation:isolate;}.cls-2{fill:#2f245b;}.cls-3{fill:#8681bd;}.cls-4{fill:#e2e4f4;}.cls-23,.cls-5,.cls-6{fill:#fff;}.cls-6{opacity:0.32;}.cls-14,.cls-21,.cls-24,.cls-7{fill:none;stroke-miterlimit:10;}.cls-14,.cls-7{stroke:#16182f;}.cls-14,.cls-21,.cls-7{stroke-width:1.83px;}.cls-8{fill:#e98b75;}.cls-9{fill:#e84152;}.cls-10{fill:#323775;}.cls-11{fill:#22254d;}.cls-12{fill:#16182f;}.cls-13{fill:#40448b;}.cls-14{stroke-dasharray:1.79 7.18;}.cls-15{fill:#f7b39e;}.cls-16{fill:#e8a08f;}.cls-17{fill:#010101;}.cls-18{fill:#454545;}.cls-19{fill:#202121;}.cls-20{fill:#f4a08d;}.cls-21{stroke:#010101;}.cls-22{fill:#e55c82;}.cls-24{stroke:#cacde9;stroke-width:2.61px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "shadow"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  "data-name": "Vector 4",
  className: "cls-1",
  d: "M326,532.15c137.52,0,249-4.17,249-9.3s-111.48-9.3-249-9.3-249,4.16-249,9.3S188.48,532.15,326,532.15Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "clock"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  "data-name": "Vector 5",
  className: "cls-2",
  d: "M334.59,472.66,312.8,511.15a7.1,7.1,0,0,0-.93,3.57,7.2,7.2,0,0,0,1,3.57,7.2,7.2,0,0,0,6.19,3.56h8.63a34.44,34.44,0,0,0,8.15-1l52.61-12.94Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  "data-name": "Vector 6",
  className: "cls-2",
  d: "M512.35,472.66l21.79,38.49a7.17,7.17,0,0,1,0,7.15,7.17,7.17,0,0,1-6.22,3.55h-8.6a34.44,34.44,0,0,1-8.15-1l-52.61-12.94Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  "data-name": "Vector 7",
  className: "cls-2",
  d: "M409,258.68h27.65a14,14,0,0,1,14,14v7.38H394.93v-7.38a14,14,0,0,1,14-14Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  "data-name": "Vector 8",
  className: "cls-2",
  d: "M495.08,282.61l9.51,6.41a14,14,0,0,1,3.78,19.43l-.68,1-32.72-22,.65-1a14,14,0,0,1,3.88-3.86,13.72,13.72,0,0,1,5.06-2.09,14,14,0,0,1,5.47,0,14.24,14.24,0,0,1,5.05,2.11Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_9",
  "data-name": "Vector 9",
  className: "cls-3",
  d: "M421.84,519.07A123.45,123.45,0,1,0,298.39,395.62,123.45,123.45,0,0,0,421.84,519.07Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_10",
  "data-name": "Vector 10",
  className: "cls-4",
  d: "M421.84,500.5A104.88,104.88,0,1,0,317,395.62,104.88,104.88,0,0,0,421.84,500.5Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_11",
  "data-name": "Vector 11",
  className: "cls-5",
  d: "M421.84,449.45A53.83,53.83,0,1,0,368,395.62,53.83,53.83,0,0,0,421.84,449.45Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_12",
  "data-name": "Vector 12",
  className: "cls-4",
  d: "M433,395.62a11.13,11.13,0,1,1-3.25-7.87,11.1,11.1,0,0,1,3.25,7.87Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_13",
  "data-name": "Vector 13",
  className: "cls-2",
  d: "M423.7,293.52h-2.78v9.28h2.78Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_14",
  "data-name": "Vector 14",
  className: "cls-2",
  d: "M473.18,307.34,470.75,306l-4.51,8.11,2.42,1.35Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_15",
  "data-name": "Vector 15",
  className: "cls-2",
  d: "M509.66,343.51l-1.46-2.36L500.31,346l1.46,2.36Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_16",
  "data-name": "Vector 16",
  className: "cls-2",
  d: "M524,392.89l-.12-2.78-9.27.42.12,2.78Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_17",
  "data-name": "Vector 17",
  className: "cls-2",
  d: "M512.36,443l1.24-2.49-8.3-4.15-1.24,2.49Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_18",
  "data-name": "Vector 18",
  className: "cls-2",
  d: "M477.86,481l2.29-1.57-5.23-7.66-2.29,1.56Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_19",
  "data-name": "Vector 19",
  className: "cls-2",
  d: "M429.15,497.5l2.77-.25-.83-9.24-2.77.25Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_20",
  "data-name": "Vector 20",
  className: "cls-2",
  d: "M378.66,488.15l2.54,1.13L385,480.8l-2.54-1.13Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_21",
  "data-name": "Vector 21",
  className: "cls-2",
  d: "M339.08,455.4l1.67,2.23,7.42-5.57-1.67-2.23Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_22",
  "data-name": "Vector 22",
  className: "cls-2",
  d: "M320.42,407.53l.37,2.75L330,409l-.38-2.75Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_23",
  "data-name": "Vector 23",
  className: "cls-2",
  d: "M328.39,355.69l-1,2.59,8.64,3.39,1-2.59Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_24",
  "data-name": "Vector 24",
  className: "cls-2",
  d: "M361.75,313.09l-2.22,1.68,5.6,7.4,2.22-1.67Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_25",
  "data-name": "Vector 25",
  className: "cls-2",
  d: "M386.51,304.32a.92.92,0,0,1,0,.71.9.9,0,0,1-.51.5.92.92,0,0,1-1.17-.54.91.91,0,0,1,.49-1.19.94.94,0,0,1,1.21.52Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_26",
  "data-name": "Vector 26",
  className: "cls-2",
  d: "M448,301.27a.91.91,0,0,1-.44.56.94.94,0,0,1-.7.09.88.88,0,0,1-.32-.16.92.92,0,0,1-.24-.28,1,1,0,0,1-.12-.34,1.1,1.1,0,0,1,0-.36.92.92,0,0,1,.43-.61.88.88,0,0,1,.73-.1.91.91,0,0,1,.34.17.9.9,0,0,1,.34.65,1,1,0,0,1-.05.38Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_27",
  "data-name": "Vector 27",
  className: "cls-2",
  d: "M491,326.31a.93.93,0,0,1-1.3,0,1,1,0,0,1-.28-.65.92.92,0,0,1,.26-.65,1,1,0,0,1,.3-.21.9.9,0,0,1,.36-.08.89.89,0,0,1,.36.07.79.79,0,0,1,.31.2.92.92,0,0,1,.2.31.86.86,0,0,1,.07.36.84.84,0,0,1-.07.35,1,1,0,0,1-.21.31Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_28",
  "data-name": "Vector 28",
  className: "cls-2",
  d: "M516,368.75a.95.95,0,0,1-.71-.08.88.88,0,0,1-.27-.24,1.13,1.13,0,0,1-.23-.7.92.92,0,0,1,.09-.37,1,1,0,0,1,.24-.31,1.11,1.11,0,0,1,.34-.18,1,1,0,0,1,.38,0,.82.82,0,0,1,.37.13.84.84,0,0,1,.27.26.82.82,0,0,1,.15.36.9.9,0,0,1-.08.7A.89.89,0,0,1,516,368.75Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_29",
  "data-name": "Vector 29",
  className: "cls-2",
  d: "M516.87,419.07a.91.91,0,0,1-.46-.28.88.88,0,0,1-.24-.48.91.91,0,0,1,.08-.54.82.82,0,0,1,.36-.4.91.91,0,0,1,1,0,.89.89,0,0,1,.32.44.83.83,0,0,1,0,.54.93.93,0,0,1-.42.57,1,1,0,0,1-.7.11Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_30",
  "data-name": "Vector 30",
  className: "cls-2",
  d: "M496,459.54a.93.93,0,0,1-.29-.46.92.92,0,0,1,.32-1,1,1,0,0,1,.51-.2,1,1,0,0,1,.52.12,1,1,0,0,1,.38.39,1,1,0,0,1,.09.53.91.91,0,0,1-.22.5,1,1,0,0,1-.63.32.93.93,0,0,1-.68-.22Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_31",
  "data-name": "Vector 31",
  className: "cls-2",
  d: "M455.42,487.58a1,1,0,0,1-.08-.37.83.83,0,0,1,.07-.38.81.81,0,0,1,.21-.31,1,1,0,0,1,.32-.21,1,1,0,0,1,.75.05,1.13,1.13,0,0,1,.3.24.84.84,0,0,1,.17.34.92.92,0,0,1,0,.71.94.94,0,0,1-.52.48,1,1,0,0,1-.36.06,1.06,1.06,0,0,1-.35-.09.86.86,0,0,1-.29-.21A1,1,0,0,1,455.42,487.58Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_32",
  "data-name": "Vector 32",
  className: "cls-2",
  d: "M403.47,491.75a1,1,0,0,1,.25-.48,1,1,0,0,1,.48-.26,1,1,0,0,1,.53.05.94.94,0,0,1,.42.34.87.87,0,0,1,.16.52.85.85,0,0,1-.15.51.87.87,0,0,1-.41.35,1,1,0,0,1-.54.06,1,1,0,0,1-.74-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_33",
  "data-name": "Vector 33",
  className: "cls-2",
  d: "M359.93,471.46a.77.77,0,0,1,.28-.23.88.88,0,0,1,.71-.07.76.76,0,0,1,.32.17.74.74,0,0,1,.23.27.89.89,0,0,1,.11.35,1.1,1.1,0,0,1,0,.36,1,1,0,0,1-.18.32,1,1,0,0,1-.27.23.89.89,0,0,1-.35.11,1.1,1.1,0,0,1-.36,0,1.23,1.23,0,0,1-.32-.17,1,1,0,0,1-.34-.63,1,1,0,0,1,.2-.68Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_34",
  "data-name": "Vector 34",
  className: "cls-2",
  d: "M331.22,432.67a1,1,0,0,1,.54-.06,1,1,0,0,1,.48.26.87.87,0,0,1,.25.47.91.91,0,0,1-.05.54.94.94,0,0,1-.34.42.86.86,0,0,1-.52.15,1,1,0,0,1-.52-.15,1,1,0,0,1-.34-.42.89.89,0,0,1-.07-.36.84.84,0,0,1,.07-.35.88.88,0,0,1,.2-.3.83.83,0,0,1,.3-.2Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_35",
  "data-name": "Vector 35",
  className: "cls-2",
  d: "M324.87,382.33a.9.9,0,0,1,.6.34.86.86,0,0,1-.14,1.25.94.94,0,0,1-.66.21,1,1,0,0,1-.61-.36,1,1,0,0,1-.18-.69.89.89,0,0,1,.35-.57.86.86,0,0,1,.64-.18Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_36",
  "data-name": "Vector 36",
  className: "cls-2",
  d: "M346.15,333.54a.92.92,0,0,1,.13,1.31,1,1,0,0,1-.28.23.83.83,0,0,1-.35.1.91.91,0,0,1-1-.83,1,1,0,0,1,.48-.92,1.08,1.08,0,0,1,.35-.1.88.88,0,0,1,.36,0,.92.92,0,0,1,.32.18Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_39",
  "data-name": "Vector 39",
  className: "cls-6",
  d: "M298.39,395.62a122.89,122.89,0,0,0,17.28,63,123.46,123.46,0,0,0,169.2-169.16A123.47,123.47,0,0,0,298.39,395.62Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_40",
  "data-name": "Vector 40",
  className: "cls-6",
  d: "M386,288.51a25.88,25.88,0,0,0-13.34,2.38c-15.07,6.93-61.53,32-63.08,77.82-1.86,54.76,80.75-9.29,89.11-41.77C405.53,300.14,398.52,289.75,386,288.51Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_62",
  "data-name": "Vector 62",
  className: "cls-7",
  d: "M323.87,289.89a7.23,7.23,0,0,0-.1-.91"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "guy"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_41",
  "data-name": "Vector 41",
  className: "cls-8",
  d: "M179.57,229.18s-13,5.63-16.35,9.88c-6.62,8.55-2.54,14.35-.55,16.48s5.08.42,4.6-3.36,5.82-4.88,8.31-5.42c7.21-1.58,7.73-4.54,15.13-5.29S179.57,229.18,179.57,229.18Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_42",
  "data-name": "Vector 42",
  className: "cls-8",
  d: "M172.57,233.07s37.55-21.95,40.12-43.29c3.65-30.33,2.8-36.18,12.38-43.26s16.16,13.74,16.78,28.95-3.08,35.82-14.33,47.46-35.65,22.55-47.65,22.82Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_43",
  "data-name": "Vector 43",
  className: "cls-9",
  d: "M212.65,182.54l8.07,4.84,11.9-41.21-18.36,8.92Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_44",
  "data-name": "Vector 44",
  className: "cls-5",
  d: "M223.17,446.67l5.07,20.85L248.52,463l-6.28-23.15Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_45",
  "data-name": "Vector 45",
  className: "cls-10",
  d: "M195.74,358.25c8.84,41.43,24.95,91.44,24.95,91.44S232.54,457.82,247,448c0,0-9.66-88.91-11.52-106.87a193.94,193.94,0,0,1-39.72,17.11Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_46",
  "data-name": "Vector 46",
  className: "cls-11",
  d: "M255.39,474.3a2.5,2.5,0,0,0,.4-1.8c-.51-3-2.37-12.52-6.34-16.4-4.74-4.63-5.47,7.21-17.32,6.48s-9.93,9-18.34,11.91-22.41,3.65-20.15,11.56c1.12,4,11.1,5.15,25.2,3.08,4.63-.68,12-4.42,16.46-5.76,4.73-1.43,9.65-.72,13.22-2.91a22.27,22.27,0,0,0,6.87-6.16Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_47",
  "data-name": "Vector 47",
  className: "cls-12",
  d: "M193.39,484.26s11.46,4.87,23,1.58,14.82-8.23,22.22-7.41S255,468.29,255,468.29l.89,3.57s1,1-1.14,3.39a22.15,22.15,0,0,1-6.58,5.44,19.38,19.38,0,0,1-8,1.76,33.44,33.44,0,0,0-10.76,3.61c-7.25,3.89-18.78,4.71-18.78,4.71s-8.56.66-14.49-1.56a3.72,3.72,0,0,1-2.33-2.82Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_48",
  "data-name": "Vector 48",
  className: "cls-11",
  d: "M208.14,351.45l32.79,99.75,5.9-3.22-10.24-98.41-23.44-4.91Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_49",
  "data-name": "Vector 49",
  className: "cls-5",
  d: "M110,412.75,95.06,428.21l14.64,14.73,16.19-17.71Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_50",
  "data-name": "Vector 50",
  className: "cls-11",
  d: "M323.07,257.31,273,264.11s-41.63,16.51-65.07,37.57c-5.33,4.79-11.72,13.78-18.41,24.8a6,6,0,0,0,.79,7.19,6.07,6.07,0,0,0,2.12,1.45,173.27,173.27,0,0,0,39.71,10.93c19.29-9.23,68.45-25.77,80.54-34.2C327.29,301.67,330.17,281.85,323.07,257.31Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_51",
  "data-name": "Vector 51",
  className: "cls-13",
  d: "M270.72,282.45s-44.24,7-71.72,22.41-92.76,105.47-92.76,105.47.44,14.36,16.89,20.22c0,0,75.23-68.72,81.38-74.19s78-11.78,94.47-18.63c28.44-11.87,32.53-36.23,31-61.74Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_52",
  "data-name": "Vector 52",
  className: "cls-11",
  d: "M101.6,453.89s10.67-7.07,12.79-13.36-8.87-1.78-13.36-12.78-12.42-5-18.7-11.34-13-18.6-19.17-13.13S82.56,452.55,101.6,453.89Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_53",
  "data-name": "Vector 53",
  className: "cls-12",
  d: "M65.06,402.13s-2.07,6.14,7.57,20.7c18.21,27.47,30.45,29,31.76,29.13V452l-2.81,1.86s-11,.29-24.8-18.46c-9.3-12.61-11.28-13-14.66-28.6a4.11,4.11,0,0,1,.06-2.09A4,4,0,0,1,63.29,403a3.6,3.6,0,0,1,1.77-.84Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_54",
  "data-name": "Vector 54",
  className: "cls-12",
  d: "M95.73,421.4s2.72,2.46,1.43,4.72-1.63,3.87,1.6,4.52a10.37,10.37,0,0,1,6.6,4.7c1.29,1.94,9.19,4.38,9.19,4.38s1.09-2.3-4.37-3.82a15.28,15.28,0,0,1-8.28-6.34S99.78,422.83,95.73,421.4Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_55",
  "data-name": "Vector 55",
  className: "cls-5",
  d: "M79.52,413.28a54.67,54.67,0,0,0-2.68,5.36c-.16.81,1.93,2.91,2.74,3.07s3.1-5,3.1-5Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_56",
  "data-name": "Vector 56",
  className: "cls-5",
  d: "M84.26,418s-2.27,4.26-1.62,5.23,3.7,2.43,4.67,1.78S89,419.71,89,419.71A38,38,0,0,1,84.26,418Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_57",
  "data-name": "Vector 57",
  className: "cls-5",
  d: "M208.63,476s2,4.11,3.63,4.11,4.94-.82,4.94-1.64-3.29-4.12-3.29-4.12Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_58",
  "data-name": "Vector 58",
  className: "cls-5",
  d: "M216.65,473s3.84,3.77,4.66,3.77,4.12-2.47,4.12-3.29-5.56-3.74-5.56-3.74Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_59",
  "data-name": "Vector 59",
  className: "cls-12",
  d: "M225.43,463.75s2.47,4.81,6.58,4,5.76-4.11,9.88-4.94,4-7.24,4-7.24-4,5.6-8.15,6.42S229.54,461.39,225.43,463.75Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_60",
  "data-name": "Vector 60",
  className: "cls-7",
  d: "M113.69,425l.6-.68"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_61",
  "data-name": "Vector 61",
  className: "cls-14",
  d: "M119,419c15.38-17.55,59.71-67.77,73.93-80.06,17.31-15,85.44-23.83,85.44-23.83s18.84-6.67,20.45-21.59"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_63",
  "data-name": "Vector 63",
  className: "cls-10",
  d: "M190.23,311.13s7.78,2.76-1,12.75-19.54,15.59-19.29,7.12C170,331,181.46,317.41,190.23,311.13Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_64",
  "data-name": "Vector 64",
  className: "cls-9",
  d: "M301.87,303.64c26.36-4.19,32.42-29.19,29.7-55.73A151.33,151.33,0,0,0,325,217.19c-12.71-39.72-35.34-77.56-63.94-83.91s-39.63,18.56-42,46c-1.81,20.82-.88,92.2-13.59,108.09C196.55,298.61,258.92,310.47,301.87,303.64Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_65",
  "data-name": "Vector 65",
  className: "cls-15",
  d: "M214.11,69.92S189.94,89.48,179.59,109s1.15,50.64,20.71,51.79,22.86-.11,41.43-27.62C272.8,87.18,254.39,42.3,214.11,69.92Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_66",
  "data-name": "Vector 66",
  className: "cls-15",
  d: "M256.79,105.57l7.52,35s-11.31,8.07-21,4.84S256.79,105.57,256.79,105.57Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_67",
  "data-name": "Vector 67",
  className: "cls-15",
  d: "M251.49,107s3.07,4.08,13.28,4.07,9.17-18.4,4.05-23.49-13.26,6.18-13.26,6.18L251.49,107"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_68",
  "data-name": "Vector 68",
  className: "cls-16",
  d: "M259.46,95.35s3.23-3.23,6.46-3.23,3.23,14.53-1.61,14.53-8.08-1.61-4.85-4.84-1.61-3.23,0-6.46"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_69",
  "data-name": "Vector 69",
  className: "cls-17",
  d: "M250.8,90.59l-4.25,8c0,1.2-2.75,4-3.49,4.91-6.2,8-9.43-3.29-25.58-.06-11.11,2.22-16.14-12.92-27.54-9.35,0,0-23.07,14.13-14.46,46.1s56.79,31.5,69,10.22c9.65-16.85,14.12-50.12,12.65-58.4a1.39,1.39,0,0,0-.34-.71,1.44,1.44,0,0,0-.66-.42C251,89.14,250.5,89.08,250.8,90.59Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_70",
  "data-name": "Vector 70",
  className: "cls-17",
  d: "M249.41,85.52a1.91,1.91,0,0,0,.22-1.15,1.93,1.93,0,0,0-.45-1.07,16.22,16.22,0,0,1-2.24-3.55c-.77-1.91-7.65-8-11.46-6.49-3,1.21-5.54,5.54.57,9.74C241.46,86.75,247.77,88.38,249.41,85.52Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_71",
  "data-name": "Vector 71",
  className: "cls-17",
  d: "M209.74,73.12a2,2,0,0,1,.35-1.3,2,2,0,0,1,1.08-.78A17.31,17.31,0,0,0,215,69.36c1.71-1.13,10.85-2.24,13.12,1.2,1.79,2.71,1.39,7.7-6,7.68C215.87,78.21,210,76.16,209.74,73.12Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_72",
  "data-name": "Vector 72",
  className: "cls-17",
  d: "M238.47,66.29s-14.53-9.69-9.68-24.22,30.67-12.91,33.9-1.61,1.62,25.83,9.69,30.67-2.51,17.78-2.51,17.78-10.39-4.1-12.83,5.21-6.81-2.51-6.81-2.51,6-14-.47-18.86a44.73,44.73,0,0,0-11.29-6.46Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_73",
  "data-name": "Vector 73",
  className: "cls-5",
  d: "M198.41,103.18a12.29,12.29,0,0,0,13,4.72c8.77-1.86,11.57,5.74,6.61,11s-17.75,5.67-24.86-4S194.36,97.65,198.41,103.18Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_74",
  "data-name": "Vector 74",
  className: "cls-17",
  d: "M209.2,84.05c-.67,1.16-1.84,1.74-2.61,1.29s-.86-1.75-.19-2.9,1.84-1.74,2.61-1.29S209.87,82.89,209.2,84.05Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_75",
  "data-name": "Vector 75",
  className: "cls-17",
  d: "M230.18,92.12c-.66,1.16-1.83,1.74-2.6,1.29s-.86-1.74-.19-2.9,1.84-1.74,2.61-1.29S230.87,91,230.18,92.12Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_76",
  "data-name": "Vector 76",
  className: "cls-18",
  d: "M139,274.15l53.49,32.14a1.1,1.1,0,0,0,.66.16l57.55-3.38a1.13,1.13,0,0,0,.68-.27,1.12,1.12,0,0,0,.38-.63,1.18,1.18,0,0,0-.08-.72,1.14,1.14,0,0,0-.51-.53l-61.5-32.85a1.14,1.14,0,0,0-.63-.13L139.49,272a1.21,1.21,0,0,0-.65.27,1.19,1.19,0,0,0-.36.61,1.21,1.21,0,0,0,.06.7,1.25,1.25,0,0,0,.46.53Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_77",
  "data-name": "Vector 77",
  className: "cls-19",
  d: "M150.74,276.88,193,302.3a1,1,0,0,0,.52.12l45.51-2.67a1,1,0,0,0,.54-.21.93.93,0,0,0,.3-.5.9.9,0,0,0-.07-.58.84.84,0,0,0-.4-.41l-48.63-26a1,1,0,0,0-.5-.1l-39.18,3.24a.91.91,0,0,0-.53.2.92.92,0,0,0-.31.49,1,1,0,0,0,.06.58.93.93,0,0,0,.39.42Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_78",
  "data-name": "Vector 78",
  className: "cls-19",
  d: "M138.87,272l-3-73.55,57.42,34.26V304.2Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_79",
  "data-name": "Vector 79",
  className: "cls-5",
  d: "M163,249.17c.16,3.05-.83,5.59-2.22,5.66s-2.65-2.34-2.81-5.39.83-5.6,2.22-5.67S162.87,246.11,163,249.17Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_80",
  "data-name": "Vector 80",
  className: "cls-20",
  d: "M213.68,263.06s-11.85,5.85-13.66,9.27,3.72,3.73,3.72,3.73Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_81",
  "data-name": "Vector 81",
  className: "cls-15",
  d: "M223.8,256.45s41-25.4,39.75-51.7-5-37.52,5.67-47.45,28.19,1.08,31,19.52,1.16,44-10.94,59.74-40.34,32.36-54.89,34.31Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_82",
  "data-name": "Vector 82",
  className: "cls-15",
  d: "M223.8,256.45s-15.11,8.64-18.55,14.28c-6.89,11.31-3.4,17.66-.68,20s6.46,1.62,7.41-4.57c.71-4.61,6.42-6.74,9.38-7.74,8.56-2.91,8.79-6.59,17.69-8.51S223.8,256.45,223.8,256.45Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_83",
  "data-name": "Vector 83",
  className: "cls-9",
  d: "M256.23,168l4.85,33.9s19.37,14.53,43.59,6.46c0,0,6.46-43.59-21-54.89S256.23,168,256.23,168Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_84",
  "data-name": "Vector 84",
  className: "cls-21",
  d: "M216.68,84.05a8.89,8.89,0,0,1-10.61,8.71,8.88,8.88,0,0,1,1.73-17.59,8.88,8.88,0,0,1,8.88,8.88Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_85",
  "data-name": "Vector 85",
  className: "cls-22",
  d: "M226.8,79.21s-22.14,10.48-24.47,16.31,9.32,8.15,15.15,3.49S226.8,79.21,226.8,79.21Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_86",
  "data-name": "Vector 86",
  className: "cls-23",
  d: "M214,88.53s-8.11,2.33-8.11,4.66S219.81,88.53,214,88.53Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_87",
  "data-name": "Vector 87",
  className: "cls-21",
  d: "M238.47,91.32A8.89,8.89,0,0,1,227.86,100a8.88,8.88,0,0,1,1.73-17.59,8.88,8.88,0,0,1,8.88,8.88Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_88",
  "data-name": "Vector 88",
  className: "cls-21",
  d: "M215.07,78.4l11.32,4.84"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_89",
  "data-name": "Vector 89",
  className: "cls-21",
  d: "M257.38,89.85l-18.09-.15"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "sayHi"
}, /*#__PURE__*/React.createElement("g", {
  id: "sayHi-2",
  "data-name": "sayHi"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_90",
  "data-name": "Vector 90",
  className: "cls-24",
  d: "M184.16,29.23H62.64A10.74,10.74,0,0,0,51.91,40v61.08a10.72,10.72,0,0,0,10.73,10.73h45L141.88,146V111.78h42.33a10.74,10.74,0,0,0,10.73-10.73V40a10.73,10.73,0,0,0-3.16-7.61,10.54,10.54,0,0,0-3.5-2.32A10.8,10.8,0,0,0,184.16,29.23Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_91",
  "data-name": "Vector 91",
  className: "cls-2",
  d: "M66.06,49a5.48,5.48,0,0,1,3.63-4.83A5.54,5.54,0,0,1,72.84,44a5.47,5.47,0,0,1,2.71,1.61L74.07,47A3.15,3.15,0,0,0,73,46.07a3.58,3.58,0,0,0-2.64-.15,3.26,3.26,0,0,0-1.11.68,3.13,3.13,0,0,0-.74,1,3.23,3.23,0,0,0,0,2.54,3.34,3.34,0,0,0,.74,1.05,3.26,3.26,0,0,0,1.11.68,3.09,3.09,0,0,0,1.28.18A3.21,3.21,0,0,0,73,51.77a3.15,3.15,0,0,0,1.09-.89l1.48,1.53a5.27,5.27,0,0,1-1.85,1.35,6.69,6.69,0,0,1-4.32.1,4.92,4.92,0,0,1-1.76-1.11A5.12,5.12,0,0,1,66.44,51,5.26,5.26,0,0,1,66.06,49Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_92",
  "data-name": "Vector 92",
  className: "cls-2",
  d: "M83,52.25V54H76.2V52.62L80.1,48H76.3V46.28h6.6v1.33L79,52.22Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_93",
  "data-name": "Vector 93",
  className: "cls-2",
  d: "M91.8,50.75H86a2,2,0,0,0,.81,1.18,2.09,2.09,0,0,0,1.39.36,2.6,2.6,0,0,0,1-.18,2.4,2.4,0,0,0,.88-.56l1.23,1.23a4.45,4.45,0,0,1-4.59,1,4.41,4.41,0,0,1-2-1.42,4.46,4.46,0,0,1-.94-2.25,4.07,4.07,0,0,1,.31-1.54,4,4,0,0,1,.9-1.28,3.69,3.69,0,0,1,1.33-.83,3.86,3.86,0,0,1,1.54-.24,3.72,3.72,0,0,1,1.55.25,3.49,3.49,0,0,1,1.32.85,3.69,3.69,0,0,1,.86,1.31,3.91,3.91,0,0,1,.25,1.55A2.43,2.43,0,0,0,91.8,50.75ZM86,49.53h3.76a1.94,1.94,0,0,0-.65-1.13,1.91,1.91,0,0,0-2.46,0A1.94,1.94,0,0,0,86,49.53Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_94",
  "data-name": "Vector 94",
  className: "cls-2",
  d: "M92.58,53.24l.74-1.59a5.16,5.16,0,0,0,2.65.73c1,0,1.41-.27,1.41-.7,0-1.22-4.61,0-4.61-3,0-1.45,1.3-2.45,3.53-2.45a6.25,6.25,0,0,1,2.94.67l-.73,1.57a4.4,4.4,0,0,0-2.21-.56c-1,0-1.42.3-1.42.71,0,1.3,4.62,0,4.62,3,0,1.42-1.32,2.45-3.62,2.45A6.49,6.49,0,0,1,92.58,53.24Zm4-10H99l-2.45,2H94.77Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_95",
  "data-name": "Vector 95",
  className: "cls-2",
  d: "M100.3,50.13a3.86,3.86,0,0,1,.33-1.58,4,4,0,0,1,.93-1.32A4,4,0,0,1,103,46.4a4,4,0,0,1,1.6-.21,3.51,3.51,0,0,1,3.42,2l-1.71.92a2,2,0,0,0-.71-.77,1.82,1.82,0,0,0-1-.28,2.12,2.12,0,1,0,0,4.24,1.9,1.9,0,0,0,1.78-1.07l1.71.93a3.44,3.44,0,0,1-1.41,1.49,3.53,3.53,0,0,1-2,.45,3.87,3.87,0,0,1-3-1,3.87,3.87,0,0,1-1-1.32,3.79,3.79,0,0,1-.34-1.59Zm4.61-6.84h2.38l-2.57,2H103Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_96",
  "data-name": "Vector 96",
  className: "cls-2",
  d: "M111.75,52.67a3.38,3.38,0,0,1-.38,1.42l-.81,2h-1.41l.63-2.26A1.23,1.23,0,0,1,109,52.6a1.37,1.37,0,0,1,1.36-1.24,1.41,1.41,0,0,1,.93.36,1.36,1.36,0,0,1,.44.88Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_97",
  "data-name": "Vector 97",
  className: "cls-2",
  d: "M64.23,76.09l.36-.78a1.76,1.76,0,0,0,1.16.4c.8,0,1.23-.49,1.23-1.41v-8h1v8a2,2,0,0,1-2.14,2.26A2.47,2.47,0,0,1,64.23,76.09Zm2.53-12.18a.72.72,0,0,1,.74-.7.65.65,0,0,1,.27,0,.72.72,0,0,1,.24.14.94.94,0,0,1,.16.23.6.6,0,0,1,.06.27.74.74,0,0,1,0,.29.63.63,0,0,1-.16.24.56.56,0,0,1-.24.16.71.71,0,0,1-.8-.16.73.73,0,0,1-.22-.52Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_98",
  "data-name": "Vector 98",
  className: "cls-2",
  d: "M77.31,70.32H71.06a2.68,2.68,0,0,0,.28,1.05,2.8,2.8,0,0,0,.65.87,2.68,2.68,0,0,0,.94.54,2.64,2.64,0,0,0,1.08.14,2.78,2.78,0,0,0,1.24-.24,2.83,2.83,0,0,0,1-.74l.56.65A3.93,3.93,0,0,1,70.06,70a3.58,3.58,0,0,1,.22-1.45,3.5,3.5,0,0,1,.79-1.25,3.64,3.64,0,0,1,1.22-.82,4.25,4.25,0,0,1,2.9,0,3.5,3.5,0,0,1,1.23.82,3.56,3.56,0,0,1,.78,1.25A3.49,3.49,0,0,1,77.42,70,.43.43,0,0,0,77.31,70.32Zm-6.25-.74h5.3a2.65,2.65,0,0,0-2.65-2.65,2.68,2.68,0,0,0-1.87.77A2.65,2.65,0,0,0,71.06,69.58Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_99",
  "data-name": "Vector 99",
  className: "cls-2",
  d: "M78.35,72.89l.45-.79a4.61,4.61,0,0,0,2.66.84c1.41,0,2-.48,2-1.23,0-1.94-4.9-.41-4.9-3.36,0-1.23,1-2.13,3-2.13a5,5,0,0,1,2.64.69l-.44.81a3.81,3.81,0,0,0-2.2-.63c-1.35,0-2,.52-2,1.22,0,2,4.91.51,4.91,3.37,0,1.29-1.13,2.14-3.08,2.14a5,5,0,0,1-3-.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_100",
  "data-name": "Vector 100",
  className: "cls-2",
  d: "M90.27,73.25a2.41,2.41,0,0,1-1.59.53,1.93,1.93,0,0,1-.86-.1,1.88,1.88,0,0,1-.75-.46,2,2,0,0,1-.47-.74,2.15,2.15,0,0,1-.1-.87V67.12H85.17v-.84H86.5V64.67h1V66.3h2.27v.82H87.51v4.47a1.37,1.37,0,0,0,0,.53,1.18,1.18,0,0,0,.28.45,1.23,1.23,0,0,0,.44.3,1.37,1.37,0,0,0,.53.08,1.69,1.69,0,0,0,1.1-.38Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_101",
  "data-name": "Vector 101",
  className: "cls-2",
  d: "M98.33,70.32H92.08A2.78,2.78,0,0,0,94,72.78a2.59,2.59,0,0,0,1.07.14,2.82,2.82,0,0,0,1.25-.24,2.72,2.72,0,0,0,1-.74l.57.65a3.92,3.92,0,0,1-2,1.13,4,4,0,0,1-4.09-1.55A3.94,3.94,0,0,1,91.08,70a3.42,3.42,0,0,1,.22-1.45,3.61,3.61,0,0,1,.78-1.25,3.79,3.79,0,0,1,1.23-.82,3.38,3.38,0,0,1,1.44-.26,3.56,3.56,0,0,1,2.69,1.07,3.71,3.71,0,0,1,.78,1.25A3.48,3.48,0,0,1,98.43,70,.47.47,0,0,0,98.33,70.32Zm-6.25-.76h5.3a2.65,2.65,0,0,0-5.3,0Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_102",
  "data-name": "Vector 102",
  className: "cls-2",
  d: "M112.73,69.42v4.32h-1V69.58c0-1.59-.8-2.46-2.15-2.46a2.49,2.49,0,0,0-1,.21,2.45,2.45,0,0,0-.83.6,2.42,2.42,0,0,0-.51.88,2.3,2.3,0,0,0-.11,1v3.92h-1V69.58c0-1.59-.8-2.46-2.16-2.46a2.49,2.49,0,0,0-1,.21,2.42,2.42,0,0,0-.82.6,2.31,2.31,0,0,0-.52.88,2.46,2.46,0,0,0-.11,1v3.92h-1V66.28h.9v1.36a3.06,3.06,0,0,1,1.17-1.09,3,3,0,0,1,1.57-.33,2.66,2.66,0,0,1,1.58.36,2.78,2.78,0,0,1,1.08,1.22,3.23,3.23,0,0,1,2.94-1.58,2.72,2.72,0,0,1,1.23.19,2.66,2.66,0,0,1,1,.7,2.76,2.76,0,0,1,.63,1.07A2.88,2.88,0,0,1,112.73,69.42Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_103",
  "data-name": "Vector 103",
  className: "cls-2",
  d: "M117.72,72.41l.61-.71a2.61,2.61,0,0,0,.92.89,2.52,2.52,0,0,0,1.23.33c1.23,0,1.85-.72,1.85-2.19V64.67h-3.68v-.91h4.68v6.89c0,2.1-1,3.14-2.9,3.14a3.27,3.27,0,0,1-1.53-.35,3.34,3.34,0,0,1-1.18-1Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_104",
  "data-name": "Vector 104",
  className: "cls-2",
  d: "M132,69.11v4.63h-1V72.58a2.88,2.88,0,0,1-1.12,1,2.84,2.84,0,0,1-1.46.27c-1.68,0-2.72-.89-2.72-2.17s.74-2.13,2.88-2.13h2.38v-.45a1.85,1.85,0,0,0-2.12-2,3.76,3.76,0,0,0-2.45.88l-.46-.76a4.78,4.78,0,0,1,3-1,2.81,2.81,0,0,1,1.19.11,2.75,2.75,0,0,1,1,.62,2.53,2.53,0,0,1,.64,1A2.64,2.64,0,0,1,132,69.11Zm-1,2.45V70.34H128.6c-1.46,0-1.93.57-1.93,1.33s.7,1.41,1.89,1.41a2.38,2.38,0,0,0,1.44-.41,2.41,2.41,0,0,0,.94-1.17Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_105",
  "data-name": "Vector 105",
  className: "cls-2",
  d: "M141.56,69.42v4.32h-1V69.58a2,2,0,0,0-.51-1.79,2.08,2.08,0,0,0-1.73-.67,2.41,2.41,0,0,0-1,.18,2.46,2.46,0,0,0-.87.58,2.52,2.52,0,0,0-.54.9,2.3,2.3,0,0,0-.12,1v3.92h-1V66.28h1v1.37a3.11,3.11,0,0,1,1.23-1.1,3,3,0,0,1,1.61-.33,2.86,2.86,0,0,1,1.23.19,2.89,2.89,0,0,1,1.67,1.77,2.89,2.89,0,0,1,.12,1.24Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_106",
  "data-name": "Vector 106",
  className: "cls-2",
  d: "M151,66.28v7.46h-1V72.38a2.94,2.94,0,0,1-1.15,1.09,3,3,0,0,1-1.54.35,3,3,0,0,1-1.26-.16,2.9,2.9,0,0,1-1.89-3V66.28h1v4.23c0,1.59.82,2.45,2.24,2.45a2.54,2.54,0,0,0,1-.18,2.61,2.61,0,0,0,.87-.6,2.41,2.41,0,0,0,.53-.9,2.46,2.46,0,0,0,.11-1v-4Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_107",
  "data-name": "Vector 107",
  className: "cls-2",
  d: "M152.82,72.89l.46-.79a4.49,4.49,0,0,0,2.65.84c1.42,0,2-.48,2-1.23,0-1.94-4.84-.41-4.84-3.36,0-1.23,1-2.13,2.95-2.13a5,5,0,0,1,2.65.69l-.44.81a3.87,3.87,0,0,0-2.21-.63c-1.35,0-1.94.52-1.94,1.22,0,2,4.85.51,4.85,3.37,0,1.29-1.14,2.14-3.09,2.14a5,5,0,0,1-3-.93Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_108",
  "data-name": "Vector 108",
  className: "cls-2",
  d: "M167.63,69.42v4.32h-1V69.58a2.11,2.11,0,0,0-1.3-2.32,2.16,2.16,0,0,0-.94-.14,2.47,2.47,0,0,0-1.93.74,2.52,2.52,0,0,0-.56.91,2.34,2.34,0,0,0-.12,1v3.92h-1V63.21h1v4.37a3.17,3.17,0,0,1,1.22-1,3.06,3.06,0,0,1,1.57-.31,2.79,2.79,0,0,1,1.25.17,2.85,2.85,0,0,1,1.05.7,2.78,2.78,0,0,1,.64,1.07,2.84,2.84,0,0,1,.13,1.26Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_109",
  "data-name": "Vector 109",
  className: "cls-2",
  d: "M169.76,73a.72.72,0,0,1,.06-.29.67.67,0,0,1,.16-.25.81.81,0,0,1,.24-.17.72.72,0,0,1,.29-.06.76.76,0,0,1,.55.23.79.79,0,0,1,0,1.09.82.82,0,0,1-.55.24.77.77,0,0,1-.53-.24.8.8,0,0,1-.22-.55Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_110",
  "data-name": "Vector 110",
  className: "cls-2",
  d: "M81.72,83.6l-3.26,9.94H76l-2.2-6.74-2.26,6.74H69.1L65.85,83.6h2.38l2.24,7,2.35-7H75l2.27,7,2.32-7Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_111",
  "data-name": "Vector 111",
  className: "cls-2",
  d: "M90.38,85.9,86.93,94a3.14,3.14,0,0,1-3.18,2.45,3.39,3.39,0,0,1-2.12-.69l.81-1.57a2,2,0,0,0,1.23.47c.6,0,.94-.27,1.23-.94v-.07L81.58,86h2.29L86,91.13,88.17,86Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_112",
  "data-name": "Vector 112",
  className: "cls-2",
  d: "M99.1,89.19v4.37H96.88V89.5c0-1.22-.57-1.8-1.55-1.8a1.82,1.82,0,0,0-1.83,2.06v3.78H91.28V85.9h2.13v.84A3.32,3.32,0,0,1,94.56,86a3.38,3.38,0,0,1,1.37-.23,3,3,0,0,1,2.42,1A3,3,0,0,1,99,87.86,3,3,0,0,1,99.1,89.19Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_113",
  "data-name": "Vector 113",
  className: "cls-2",
  d: "M107.86,89.19v4.36h-2.07v-1a2.54,2.54,0,0,1-2.33,1.07c-1.79,0-2.86-1-2.86-2.32s1-2.29,3.28-2.29h1.76c0-.94-.56-1.5-1.76-1.5a3.76,3.76,0,0,0-2.2.7l-.79-1.52a6,6,0,0,1,3.29-.92C106.51,85.79,107.86,86.87,107.86,89.19Zm-2.22,1.94v-.77h-1.52c-1,0-1.36.38-1.36.9s.47.91,1.23.91a1.61,1.61,0,0,0,1-.25,1.6,1.6,0,0,0,.65-.8Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_114",
  "data-name": "Vector 114",
  className: "cls-2",
  d: "M107.54,96l.6-1.6a1.66,1.66,0,0,0,.94.27c.55,0,.9-.35.9-1.11V85.9h2.22v7.62a2.65,2.65,0,0,1-.14,1.15,2.69,2.69,0,0,1-.62,1,2.64,2.64,0,0,1-1,.62,2.81,2.81,0,0,1-1.15.15,3.27,3.27,0,0,1-1.78-.43Zm2.17-12.38a1.3,1.3,0,0,1,.11-.51,1.27,1.27,0,0,1,.31-.42,1.24,1.24,0,0,1,.45-.25,1.15,1.15,0,0,1,.52,0,1.25,1.25,0,0,1,.51,0,1.28,1.28,0,0,1,.76.68,1.24,1.24,0,0,1,.1.5,1.38,1.38,0,0,1-.44.9,1.39,1.39,0,0,1-1.87,0A1.44,1.44,0,0,1,109.71,83.6Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_115",
  "data-name": "Vector 115",
  className: "cls-2",
  d: "M127.16,89.19v4.37H125V89.5c0-1.22-.57-1.8-1.46-1.8s-1.68.64-1.68,2v3.83h-2.26v-4c0-1.22-.53-1.8-1.45-1.8s-1.68.64-1.68,2v3.83h-2.2V85.9h2.11v.84a3.17,3.17,0,0,1,1.11-.77,3.05,3.05,0,0,1,1.34-.22,2.89,2.89,0,0,1,1.42.28,2.85,2.85,0,0,1,1.09,1,3.4,3.4,0,0,1,2.76-1.23C125.83,85.79,127.16,86.84,127.16,89.19Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_116",
  "data-name": "Vector 116",
  className: "cls-2",
  d: "M128.86,83.6a1.09,1.09,0,0,1,.1-.5,1.27,1.27,0,0,1,.31-.42,1.14,1.14,0,0,1,1-.3,1.25,1.25,0,0,1,.51,0,1.28,1.28,0,0,1,.76.68,1.24,1.24,0,0,1,.1.5,1.36,1.36,0,0,1-.46.86,1.4,1.4,0,0,1-.91.35,1.38,1.38,0,0,1-.91-.35,1.31,1.31,0,0,1-.46-.86Zm.25,2.3h2.22v7.64h-2.22Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_117",
  "data-name": "Vector 117",
  className: "cls-2",
  d: "M131.05,96l.6-1.6a1.63,1.63,0,0,0,.93.27c.56,0,.91-.35.91-1.11V85.9h2.26v7.62a2.81,2.81,0,0,1-.15,1.15A2.68,2.68,0,0,1,134,96.26a2.79,2.79,0,0,1-1.14.15A3.21,3.21,0,0,1,131.05,96Zm2.17-12.38a1.3,1.3,0,0,1,.11-.51,1.25,1.25,0,0,1,.3-.42,1.38,1.38,0,0,1,.46-.25,1.14,1.14,0,0,1,.52,0,1.17,1.17,0,0,1,1,.3,1.25,1.25,0,0,1,.3.42,1.1,1.1,0,0,1,.11.5,1.35,1.35,0,0,1-.45.9,1.38,1.38,0,0,1-1.86,0A1.35,1.35,0,0,1,133.22,83.6Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_118",
  "data-name": "Vector 118",
  className: "cls-2",
  d: "M154.48,89.19v4.33h-1V89.31c0-1.57-.8-2.38-2.15-2.38a2.48,2.48,0,0,0-1,.2,2.42,2.42,0,0,0-.82.6,2.31,2.31,0,0,0-.52.88,2.48,2.48,0,0,0-.11,1v3.92h-1V89.31c0-1.57-.79-2.38-2.15-2.38a2.42,2.42,0,0,0-1,.2,2.36,2.36,0,0,0-.83.6,2.29,2.29,0,0,0-.51.88,2.49,2.49,0,0,0-.12,1v3.92h-1V86.07h.84v1.36A3,3,0,0,1,145.85,86a2.69,2.69,0,0,1,2.66,1.58,3.27,3.27,0,0,1,1.25-1.2,3.23,3.23,0,0,1,1.69-.38,2.73,2.73,0,0,1,1.24.17,2.83,2.83,0,0,1,1,.69,2.9,2.9,0,0,1,.64,1.08A2.75,2.75,0,0,1,154.48,89.19Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_119",
  "data-name": "Vector 119",
  className: "cls-2",
  d: "M164.1,89.19v4.33h-1V89.31a2.08,2.08,0,0,0-.07-.93,2.27,2.27,0,0,0-.47-.81,2.18,2.18,0,0,0-.78-.52,2.06,2.06,0,0,0-.92-.12,2.34,2.34,0,0,0-1,.15,2.43,2.43,0,0,0-.89.59,2.45,2.45,0,0,0-.67,2v3.92h-1V86.07h1v1.37a3.08,3.08,0,0,1,1.22-1.1A3,3,0,0,1,161,86a2.75,2.75,0,0,1,1.24.17,2.87,2.87,0,0,1,1,.69A3.06,3.06,0,0,1,164,88,2.9,2.9,0,0,1,164.1,89.19Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_120",
  "data-name": "Vector 120",
  className: "cls-2",
  d: "M166.61,83.71a.75.75,0,0,1,.74-.71.75.75,0,0,1,.52.2.63.63,0,0,1,.16.23.63.63,0,0,1,.06.27.72.72,0,0,1-.74.65.74.74,0,0,1-.49-.18.73.73,0,0,1-.25-.47Zm.23,2.36h1v7.47h-1Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_121",
  "data-name": "Vector 121",
  className: "cls-2",
  d: "M177.17,90.11h-6.25a2.77,2.77,0,0,0,.27,1.06,2.87,2.87,0,0,0,.65.86,2.77,2.77,0,0,0,.94.54,2.64,2.64,0,0,0,1.08.14,2.84,2.84,0,0,0,1.25-.23,3,3,0,0,0,1-.75l.56.65a3.84,3.84,0,0,1-2,1.13,3.91,3.91,0,0,1-2.27-.15,3.92,3.92,0,0,1-2.54-3.55,3.62,3.62,0,0,1,.1-1.57,3.6,3.6,0,0,1,2-2.33,3.64,3.64,0,0,1,3.07,0,3.6,3.6,0,0,1,2,2.33,3.62,3.62,0,0,1,.1,1.57C177.18,89.89,177.17,90,177.17,90.11Zm-6.25-.74h5.29a2.65,2.65,0,0,0-4.52-1.88,2.64,2.64,0,0,0-.77,1.88Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_122",
  "data-name": "Vector 122",
  className: "cls-2",
  d: "M178.92,92.87a.71.71,0,0,1,.06-.28.81.81,0,0,1,.17-.24.78.78,0,0,1,.24-.16,1,1,0,0,1,.29,0,.64.64,0,0,1,.28,0,.7.7,0,0,1,.25.15,1,1,0,0,1,.16.24.92.92,0,0,1,0,.28.75.75,0,0,1-.74.74.87.87,0,0,1-.28,0,.72.72,0,0,1-.25-.16.81.81,0,0,1-.17-.24.72.72,0,0,1-.06-.29Zm.16-9.27h1.23l-.21,7h-.79Z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "big"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M421.84,395.58a4.79,4.79,0,0,1,.22-1.42,4.42,4.42,0,0,1,.71-1.34,4.15,4.15,0,0,1,3.26-1.59h28.76c6.44.06,12.36.28,16.7.63,5.67.46,9.14.88,9.14,3.7s-3.47,3.24-9.14,3.7c-3.72.3-8.62.51-14,.6v0l-2.7,0H426a4.11,4.11,0,0,1-3.26-1.59,4.42,4.42,0,0,1-.71-1.34A4.78,4.78,0,0,1,421.84,395.58Z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "small"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_37",
  "data-name": "Vector 37",
  className: "cls-2",
  d: "M424.13,344.83C424,322.94,423,306,421.82,306s-2.16,17-2.3,38.85v48.3a2.55,2.55,0,0,0,.18.95,2.34,2.34,0,0,0,.5.81,2.47,2.47,0,0,0,.75.54,2.29,2.29,0,0,0,.89.19,2.26,2.26,0,0,0,.89-.19,2.4,2.4,0,0,0,1.25-1.35,2.55,2.55,0,0,0,.18-.95v-48.3Z"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "circle"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 421.84,
  cy: 395.58,
  r: 7.08
}));

function SvgJanush(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 620 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJanush);
export default __webpack_public_path__ + "static/media/janush.54aff249.svg";
export { ForwardRef as ReactComponent };